/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsAuditReportsGetGipAltReportEvidenceExportUrlQueryResponse, AuditReportsAuditReportsGetGipAltReportEvidenceExportUrlPathParams, AuditReportsAuditReportsGetGipAltReportEvidenceExportUrl401, AuditReportsAuditReportsGetGipAltReportEvidenceExportUrl403, AuditReportsAuditReportsGetGipAltReportEvidenceExportUrl404 } from "../models/AuditReportsAuditReportsGetGipAltReportEvidenceExportUrl";

export function getAuditReportsAuditReportsGetGipAltReportEvidenceExportUrlUrl(id: AuditReportsAuditReportsGetGipAltReportEvidenceExportUrlPathParams["id"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/reports/gip-alt/report/${id}/export-url` as const }
  return res
}

/**
 * @summary Get export URL for existing report
 * {@link /audit-reports/v1/reports/gip-alt/report/:id/export-url}
 */
export async function auditReportsAuditReportsGetGipAltReportEvidenceExportUrl(id: AuditReportsAuditReportsGetGipAltReportEvidenceExportUrlPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsAuditReportsGetGipAltReportEvidenceExportUrlQueryResponse, ResponseErrorConfig<AuditReportsAuditReportsGetGipAltReportEvidenceExportUrl401 | AuditReportsAuditReportsGetGipAltReportEvidenceExportUrl403 | AuditReportsAuditReportsGetGipAltReportEvidenceExportUrl404>, unknown>({ method : "GET", url : getAuditReportsAuditReportsGetGipAltReportEvidenceExportUrlUrl(id).url.toString(), ... requestConfig })
  return res.data
}